/*
 * Merchant: "when you are on the manifest shop all section, have a toggle
 * for reproduction items and then tag any items made by rothco as
 * reproductions/replica and only show those items on the shop all if the
 * toggle is on 'Show reproductions'. It should be on by default."
 *
 * Detection: Rothco isn't its own Shopify vendor in this catalog — every
 * Rothco listing here (12 products: flight jacket, shemaghs, LC-1
 * suspenders, M-65 pants, etc.) is sold through vendor "Military Uniform
 * Supply, Inc." with no distinguishing tag, so vendor/tag matching can't
 * find them. The one reliable signal is the product title itself, which
 * this Collective import always prefixes with the real brand name
 * ("Rothco MA-1 Flight Jacket", "Rothco Vintage M-65 Field Pants", ...),
 * confirmed against a live export of the full catalog before writing this.
 *
 * Scope: only the Manifest's full counter with activeCat 'All' — the
 * merchant's own words, and also the only view where hiding one brand's
 * items wouldn't fight the Shop Hub's separate Surplus/Survival/Modern/
 * Other grouping (assets/sat-shop-groups-patch.js), which already sorts
 * these same items into real departments. Loaded in layout/theme.liquid
 * right after sat-shop-groups-patch.js, so for activeCat 'All' (which that
 * patch's own visibleProducts wrapper passes straight through unfiltered)
 * this sees the exact same list the counter is about to render.
 *
 * Toggle UI is a styled div + onClick (matching the department chips'
 * convention elsewhere in this template) rather than a native checkbox —
 * this custom template runtime doesn't bind the `checked` boolean
 * attribute anywhere else, but onClick on a plain div is used throughout
 * (see every product card, every chip). state.showRepro is left undefined
 * until first toggled; `!== false` reads that as on, matching "on by
 * default" without needing to touch the component's constructor.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }
  var proto = window.SATComponent.prototype;

  var ROTHCO_NAME = /^rothco\b/i;
  function isRepro(p) { return ROTHCO_NAME.test(p.name || ''); }

  var origVP = proto.visibleProducts;
  proto.visibleProducts = function () {
    var list = origVP.call(this);
    if (this.state.activeCat !== 'All') { return list; }
    if (this.state.showRepro === false) {
      return list.filter(function (p) { return !isRepro(p); });
    }
    return list;
  };

  var origRV = proto.renderVals;
  proto.renderVals = function () {
    var out = origRV.call(this);
    var self = this, s = this.state;
    var on = s.showRepro !== false;
    out.reproToggleShow = s.activeCat === 'All' ? 'flex' : 'none';
    out.reproToggleTrackStyle = on ? 'background:#3F7A54;' : 'background:rgba(244,239,227,.18);';
    out.reproToggleKnobStyle = on ? 'left:17px;' : 'left:2px;';
    out.reproToggleFlip = function (e) {
      if (e && e.preventDefault) { e.preventDefault(); }
      self.setState({ showRepro: !on });
    };
    return out;
  };
})();
